module.exports = __webpack_public_path__ + "img/icon2.fce9573d.png";